import {PropsWithChildren} from "react";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";
import {UB_ASSISTANT_ENABLED} from "../utils/featureFlags";
import {usePostMessage} from "../hooks/usePostMessage";

export const ProductEnabledProvider = ({children}: PropsWithChildren) => {
    const {postMessage} = usePostMessage();
    const isNotEmbedded = window.self === window.top;

    const assistantEnabled = useBooleanFeatureFlag(
        UB_ASSISTANT_ENABLED.key,
        UB_ASSISTANT_ENABLED.defaultValue,
    );

    if (!assistantEnabled) {
        postMessage("assistantEnabled=false");
        return isNotEmbedded ? children : null;
    }

    postMessage("assistantEnabled=true");

    return children;
};
